import React, { useState, useEffect } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { projectFirestore } from "../../../firebase/config";
import { onSnapshot, collection, query, where } from "firebase/firestore";
import { Table, Form } from "react-bootstrap";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// style
import "./Meseros.css";

export default function Meseros() {
  const [meseros, setMeseros] = useState([]);
  const [filterText, setFilterText] = useState("");
  const { register } = useAuthContext();
  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  useEffect(() => {
    const Listener = () => {
      const filtros = [
        { campo: "id_puesto", operador: "==", valor: register.id },
        { campo: "id_tipo_puesto", operador: "==", valor: "Mesero" },
      ];
      let q = query(collection(projectFirestore, "personal"));
      filtros.forEach((filtro) => {
        const { campo, operador, valor } = filtro;
        q = query(q, where(campo, operador, valor));
      });
      onSnapshot(q, (docs) => {
        const documentosColeccion = [];
        docs.docs.forEach((doc) => {
          //console.log(doc.id, '=>', doc.data());
          let data = doc.data();
          data.id = doc.id;
          const filtrosa = [
            { campo: "id", operador: "==", valor: data.id_usuario },
          ];
          let qu = query(collection(projectFirestore, "users"));
          filtrosa.forEach((filtroc) => {
            const { campo, operador, valor } = filtroc;
            qu = query(qu, where(campo, operador, valor));
          });
          onSnapshot(qu, (docsu) => {
            const dataU = docsu.docs[0].data();
            data.usuario = dataU.fullName;
            data.correo = dataU.email;
            data.rfc = dataU.rfc;
            data.telefono = dataU.telefono;
            documentosColeccion.push(data);
            setMeseros(documentosColeccion);
          });
        });
      });
    };
    Listener();
  }, []);

  return (
    <div>
      <br />
      <h4 className="page-title">MESEROS</h4>
      <br />
      <div className="container">
        <div className="row">
          <div className="col-sm-12 left">
            <br />
            <br />
          </div>

          <div className="col-sm-3">
            <div className="input-group">
              <Form.Control
                className="form-control border-end-0 border rounded-pill"
                type="text"
                aria-describedby="search-icon"
                placeholder="Busqueda general"
                value={filterText}
                onChange={handleFilterTextChange}
              />
              <span className="input-group-append">
                <button
                  className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                  type="button"
                >
                  <FontAwesomeIcon icon={faSearch} />
                </button>
              </span>
            </div>
          </div>

          <div className="col-sm-12">
            <Table striped bordered hover border="2" id="ex-tblMeseros">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Activo</th>
                  <th>Mesas</th>
                  <th>RFC</th>
                  <th>Telefono</th>
                  <th>Correo</th>
                </tr>
              </thead>
              <tbody>
                {meseros.map((item) => (
                  <tr key={item.id}>
                    <td>{item.usuario}</td>
                    <td></td>
                    <td></td>
                    <td>{item.rfc}</td>
                    <td>{item.telefono}</td>
                    <td>{item.correo}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
}
